import { Permit_ListItem } from "../models/Permit_ListItem";
import Map from "./common/Map";
import { Checkbox, Menu } from "semantic-ui-react";
import { useEffect, useState } from "react";
import { MapItem } from "../utils/arcgisUtils";
import { Project } from "../models/Project";
import { useAppContext } from "../hooks/useAppContext";
import { createPermitMapItem, createProjectMapItem } from "../utils/boundaryUtils";

interface Props {
  permits?: Permit_ListItem[] | null;
  currentProject?: Project;
  onPermitViewClicked: (permitId: string) => void;
}

const PermitsBoundariesOnMap = ({ permits, currentProject, onPermitViewClicked }: Props) => {
  const { currentOrganization, organizationConfiguration } = useAppContext();
  const [items, setItems] = useState<MapItem[]>([]);
  const [showMapLegendSelected, setShowMapLegendSelected] = useState(false);
  const [showMapLayersListSelected, setShowMapLayersListSelected] = useState(false);

  useEffect(() => {
    if (currentProject && currentProject.boundaries && permits) {
      setItems([createProjectMapItem(currentProject)]);
      permits
        .filter((permit) => permit.areas)
        .map((permit) => setItems((prev) => [...prev].concat(createPermitMapItems(permit))));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProject, permits]);

  const createPermitMapItems = (permit: Permit_ListItem): MapItem[] => {
    return permit.areas.map((boundary) =>
      createPermitMapItem(permit.id, permit.number, permit.locationOfWork || "", boundary)
    );
  };

  return (
    <>
      {permits && (
        <>
          <Menu attached="top" style={{ marginTop: "-14px", border: "0", backgroundColor: "#f1f1f1" }}>
            <Menu.Item header>Map options:</Menu.Item>
            <Menu.Item position="right">
              <Checkbox
                slider
                label="Layers list"
                checked={showMapLayersListSelected}
                onChange={(e, data) => {
                  setShowMapLayersListSelected(data.checked ?? false);
                  if (data.checked) {
                    setShowMapLegendSelected(!data.checked);
                  }
                }}
              ></Checkbox>
            </Menu.Item>
            <Menu.Item>
              <Checkbox
                slider
                label="Map legend"
                checked={showMapLegendSelected}
                onChange={(e, data) => {
                  setShowMapLegendSelected(data.checked ?? false);
                  if (data.checked) {
                    setShowMapLayersListSelected(!data.checked);
                  }
                }}
              ></Checkbox>
            </Menu.Item>
          </Menu>
          {organizationConfiguration?.system && (
            <Map
              mapConfig={organizationConfiguration.system.arcGisMap}
              webMapItemId={currentOrganization?.esriConfig?.webMapItemId}
              items={items}
              onPopupClick={onPermitViewClicked}
              showLayersList={showMapLayersListSelected}
              showLegend={showMapLegendSelected}
            ></Map>
          )}
        </>
      )}
    </>
  );
};

export default PermitsBoundariesOnMap;
